export default {
    topics: [
        {
            title: ' updateFacebookProfile ',
            href: 'sm-visitor-updateFacebookProfile.html',
            attributes: { 'data-id': 'sm-visitor-updateFacebookProfile' },
            menu: { hasChildren: false },
            tocID: 'sm-visitor-updateFacebookProfile-d66e4128',
            topics: [],
        },
    ],
};

